import { ArrowClockwise } from '@phosphor-icons/react'
import { Button } from '@/components/ui/button'
import { useVersionCheck } from '@/hooks/use-version-check'

export function UpdateBanner() {
  const { updateAvailable } = useVersionCheck()

  if (!updateAvailable) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between gap-3 border-t border-border bg-background px-4 py-3 shadow-lg"
    >
      <p className="text-sm font-medium" style={{ color: 'var(--naia-text-primary)' }}>
        Mise à jour disponible
      </p>
      <Button
        size="lg"
        onClick={() => location.reload()}
        className="min-h-[44px] min-w-[44px] shrink-0"
      >
        <ArrowClockwise size={16} />
        Recharger
      </Button>
    </div>
  )
}
